import { useEffect, useRef } from 'react';
import { convertToArray, isCustomCategory, UNITS_MAP } from 'Details/utils';
import { defaultDimensions } from 'utils/apiRequests';
import { CHART_TYPES } from 'Details/DetailsChart/DetailsChart';
import { DIRECT, INDIRECT } from './constants';

export const usePrevious = value => {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};

export const safeSum = (a, b) => {
	return (a || 0) + (b || 0);
};

export const getPropsFromQueryStringConsumer = state => {
	let {
		unit,
		currency,
		dateFrom,
		dateTo,
		showNonSourceable,
		showAllCategories,
		showTailSpend,
		showAllSegments,
		waterfallShowAdjusted,
		waterfallShowL4Level,
		dimensions,
		setQueryStringStateAndPush,
		tailSpend,
		customFilters,
		customFiltersValues,
		comparisonChartDimension,
		showHarmonizedVendors,
		showNegativeSpend,
		waterfallFilter,
		chartType,
		storedQueryId,
		companies,
		pmiBreadcrumbs,
		setQueryStringStateAndReplace,
	} = state;

	showAllSegments = !!showAllSegments && showAllSegments !== 'false';

	return {
		tailSpend,
		currency,
		dateFrom,
		dateTo,
		showNonSourceable: !!showNonSourceable && showNonSourceable !== 'false',
		waterfallShowClientCategory: isCustomCategory(dimensions),
		dimensions: dimensions || defaultDimensions,
		showAllCategories: !!showAllCategories && showAllCategories !== 'false',
		showTailSpend: !!showTailSpend && showTailSpend !== 'false',
		waterfallShowAdjusted:
			!!waterfallShowAdjusted && waterfallShowAdjusted !== 'false',
		waterfallShowL4Level:
			!!waterfallShowL4Level && waterfallShowL4Level !== 'false',
		setQueryStringStateAndPush,
		scaleSymbol: unit || '',
		scaleTier: UNITS_MAP[unit] || UNITS_MAP.m,
		showNegativeSpend: !!showNegativeSpend && showNegativeSpend !== 'false',
		customFilters: convertToArray(customFilters),
		customFiltersValues: convertToArray(customFiltersValues),
		storedQueryId,
		waterfallFilter,
		comparisonChartDimension: comparisonChartDimension,
		showHarmonizedVendors:
			!!showHarmonizedVendors && showHarmonizedVendors !== 'false',
		showAllSegments,
		chartType: chartType || CHART_TYPES.waterfall,
		companies: convertToArray(companies),
		pmiBreadcrumbs: convertToArray(pmiBreadcrumbs),
		setQueryStringStateAndReplace,
	};
};

export const getSpendTypeFromBreadcrumbs = breadcrumbs => {
	if (!breadcrumbs) {
		return;
	}

	if (breadcrumbs.includes(INDIRECT)) {
		return 1;
	}

	if (breadcrumbs.includes(DIRECT)) {
		return 0;
	}

	return;
};

export const azSorter = (a, b) => (a > b ? 1 : a < b ? -1 : 0);

export const agGridRowSelector = rowIndex =>
	`.ag-center-cols-container [row-id="${rowIndex}"]`;
